export default __webpack_public_path__ + "static/media/helm_of_the_farseeker.4d1d331e.jpg";